import React, { lazy } from 'react';
import { BookOpen, PenTool, Users, Heart } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
const features = [{
  icon: BookOpen,
  title: 'Módulo de Fluidez Lectora',
  description: 'Ejercicios de 10 min/día para leer con confianza'
}, {
  icon: PenTool,
  title: 'Módulo de Escritura',
  description: 'Actividades divertidas para mejorar ortografía'
}, {
  icon: Users,
  title: 'Módulo de Comprensión',
  description: 'Dinámicas para entender y explicar textos'
}, {
  icon: Heart,
  title: 'Guía para Padres',
  description: 'Cómo acompañar a tu hijo paso a paso'
}];
const previewImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/kWnP9LQKCNwBCmJSZTryRs/Captura_de_pantalla_2026-02-10_a_la(s)_8.40.36_a._m..png',
  alt: 'Fichas de palabras y sílabas coloridas'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/hTMcXnNQrnyMBrdztBL57s/Captura_de_pantalla_2026-02-10_a_la(s)_8.41.03_a._m..png',
  alt: 'Actividad de colorear la letra A'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/r5ApQE1yTzGiyPABiPEmv2/Captura_de_pantalla_2026-02-10_a_la(s)_8.41.24_a._m..png',
  alt: 'Niña practicando lectura con el material'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/scKBfdGZG2Hg9DbVCLoR5F/Captura_de_pantalla_2026-02-10_a_la(s)_8.41.41_a._m..png',
  alt: 'Página de sílabas con la letra B'
}];
const previewImagesBottom = [{
  src: 'https://cdn.magicpatterns.com/uploads/8R9ePyYsukFPuuQAvvCquR/Captura_de_pantalla_2026-02-10_a_la(s)_8.42.00_a._m..png',
  alt: 'Niño practicando escritura de letras'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/sdpDVBiRX4BTVd5TyVTpft/Captura_de_pantalla_2026-02-10_a_la(s)_8.42.24_a._m..png',
  alt: 'Hojas de descifrando palabras'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/taGwfJj8UqvMv7Azxiyb5H/Captura_de_pantalla_2026-02-10_a_la(s)_8.42.52_a._m..png',
  alt: 'Regalos exclusivos y contenido del silabario'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/mbE7NfEeJiPVHkxeRZ9w9P/Captura_de_pantalla_2026-02-10_a_la(s)_8.43.14_a._m..png',
  alt: 'Pirámide de lectura - Sofía come una manzana roja'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/k1BiWP3aUteLChxX1eNGaa/Captura_de_pantalla_2026-02-10_a_la(s)_8.43.34_a._m..png',
  alt: 'Hojas de palabras trisílabas con ilustraciones'
}];
export function WhatsInsideSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  return <section className="pt-10 pb-10 px-4 bg-[#FDF8F3]" data-id="element-139">
      <style data-id="element-140">{`
        @keyframes carouselScroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @keyframes carouselScrollReverse {
          0% { transform: translateX(-50%); }
          100% { transform: translateX(0); }
        }
        .carousel-track {
          animation: carouselScroll 20s linear infinite;
        }
        .carousel-track:hover {
          animation-play-state: paused;
        }
        .carousel-track-reverse {
          animation: carouselScrollReverse 22s linear infinite;
        }
        .carousel-track-reverse:hover {
          animation-play-state: paused;
        }
      `}</style>

      <div className="max-w-2xl mx-auto" data-id="element-141">
        <div className="text-center mb-10" data-id="element-142">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-3" data-id="element-143">
            Todo lo que recibes hoy
          </h2>
          <p className="text-gray-500 mb-6" data-id="element-144">
            Materiales listos para usar desde el primer día
          </p>
          <div className="w-16 h-1 bg-[#E8A84C] rounded-full mx-auto" data-id="element-145"></div>
        </div>

        {/* Image Preview Carousel */}
        <div className="mb-8 -mx-4 overflow-hidden" data-id="element-146">
          <div className="carousel-track flex gap-4 w-max" data-id="element-147">
            {/* Duplicate images for seamless loop */}
            {[...previewImages, ...previewImages].map((img, index) => <div key={index} className="shrink-0 w-52 h-72 md:w-60 md:h-80 rounded-2xl overflow-hidden shadow-md border-2 border-white" data-id="element-148">
                <img src={img.src} alt={img.alt} className="w-full h-full object-cover" loading="lazy" data-id="element-149" />
              </div>)}
          </div>
        </div>

        <div ref={ref} className={`space-y-5 ${isVisible ? 'reveal-visible' : 'reveal-hidden'}`} data-id="element-150">
          {features.map((feature, index) => <div key={index} className="bg-white p-6 rounded-2xl border border-gray-100 shadow-[0_2px_12px_rgba(0,0,0,0.04)] flex items-center gap-5" data-id="element-151">
              <div className="shrink-0 w-14 h-14 rounded-full bg-[#FFF0DC] flex items-center justify-center" data-id="element-152">
                <feature.icon className="w-6 h-6 text-[#E8A84C]" data-id="element-153" />
              </div>
              <div data-id="element-154">
                <h3 className="text-lg font-bold text-gray-800" data-id="element-155">
                  {feature.title}
                </h3>
                <p className="text-gray-500 text-sm mt-1" data-id="element-156">
                  {feature.description}
                </p>
              </div>
            </div>)}
        </div>

        {/* Bottom Image Preview Carousel */}
        <div className="mt-8 -mx-4 overflow-hidden" data-id="element-157">
          <div className="carousel-track-reverse flex gap-4 w-max" data-id="element-158">
            {[...previewImagesBottom, ...previewImagesBottom].map((img, index) => <div key={index} className="shrink-0 w-52 h-72 md:w-60 md:h-80 rounded-2xl overflow-hidden shadow-md border-2 border-white" data-id="element-159">
                  <img src={img.src} alt={img.alt} className="w-full h-full object-cover" loading="lazy" data-id="element-160" />
                </div>)}
          </div>
        </div>
      </div>
    </section>;
}